import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Paginator from '../../components/Paginator';

const List = () => {
    const [categories, setCategories] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    useEffect(() => {
        getData(page, search);
    }, [page, search]);

    const getData = async (p = 1, s = '') => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: 'GET',
                url: `/admin/expense-categories?page=${p}&search=${s}`
            });
            if (response.data.status) {
                setCategories(response.data.data.categories);
                setPagination(response.data.data.pagination);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Failed to fetch expense categories');
        } finally {
            setIsLoader(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await ApiService.request({
                        method: 'DELETE',
                        url: `/admin/expense-categories/${id}`
                    });
                    if (response.data.status) {
                        toast.success(response.data.message);
                        getData(page, search);
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error('Failed to delete');
                }
            }
        });
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            Expense Categories
                        </h1>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to="/expense-categories/create" className="btn btn-sm fw-bold btn-base">
                            Add Expense Category
                        </Link>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="d-flex align-items-center position-relative my-1">
                                    <span className="svg-icon svg-icon-1 position-absolute ms-6">
                                        <i className="fas fa-search"></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control form-control-solid w-250px ps-15"
                                        placeholder="Search Categories"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body py-4">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                            <th className="min-w-125px">Name</th>
                                            <th className="min-w-125px">Description</th>
                                            <th className="text-end min-w-100px">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold">
                                        {categories.length > 0 ? (
                                            categories.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.name}</td>
                                                    <td>{item.description || '-'}</td>
                                                    <td className="text-end">
                                                        <Link
                                                            to={`/expense-categories/edit/${item.id}`}
                                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </Link>
                                                        <button
                                                            onClick={() => handleDelete(item.id)}
                                                            className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    No data found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <Paginator
                                pagination={pagination}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
